import React, { useContext, useEffect, Suspense, useState } from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import '../LocalizeLang/I18nLang';
import HeaderComponent from '../Header';
import { AppUtils } from '@gscope-mfe/app-bridge';
import AlertBanner from '../AlertBanner';
import Loader from '../Loader';
import classes from './Layout.module.css';
import { Utilities, PubSub } from '@gscope-mfe/app-bridge';
import UpdateBanner from '../UpdateBanner';

const { Grid } = MaterialUiCore;
const appBridgePubSub = new PubSub('@gscope-mfe/common-components');

const Layout = ({ children, userPref, toggleIssueReporter }) => {
    const { setFooterConfig, userInfo, initializeHeader, headerConfig } = AppUtils.get();
    const [showUpdateBanner, setShowUpdateBanner] = useState(false);
    /**
     * @name renderFooterMessage
     * @desc return the footer messge
     */

    const renderFooterMessage = () => (
        <div className={classes.footerMessage}>
            <p className={classes.fs12}>
                ©Copyright
                {new Date().getFullYear()}, Wal-Mart Stores, Inc. All Rights Reserved.
            </p>
            <p className={`mt-2 ${classes.fs12}`}>
                Best viewed in Google Chrome & Internet Explorer version 11 and above
            </p>
        </div>
    );

    useEffect(() => {
        initializeHeader(); // Setting Footer config

        setFooterConfig({
            message: renderFooterMessage(),
        });
        const token = appBridgePubSub.subscribeToStateUpdate(
            '@gscope-mfe/app-bridge',
            (moduleName, { event, data }) => {
                if (event === 'SHOW_UPDATE_BANNER') {
                    setShowUpdateBanner(data);
                }
            },
        );
        return () => appBridgePubSub.unsubscribeToStateUpdate(token);
    }, []);
    return (
        <Grid
            container
            direction="column"
            className={classes.root}
            style={
                headerConfig.appBackGround
                    ? {
                          backgroundColor: headerConfig.appBackGround,
                      }
                    : {}
            }
        >
            {((userInfo.authToken && cookies.get('loggedIn')) || isSellerWfs()) && (
                <Grid item className={classes.header}>
                    <Suspense fallback={<Loader show />}>
                        <HeaderComponent userPref={userPref} toggleIssueReporter={toggleIssueReporter} />
                    </Suspense>
                </Grid>
            )}
            <div
                className={
                    classes.contentContainer +
                    (function () {
                        if (headerConfig.hideNavigation) return classes.hiddenStrip;
                        else return '';
                    })()
                }
                style={headerConfig.hideHeader ? { height: '100vh' } : {}}
            >
                <div className={classes.extraDiv}></div>
                <Grid
                    item
                    container
                    direction="column"
                    className={classes.pageContainer}
                    style={{ marginTop: headerConfig.hideHeader ? '0px' : '10px' }}
                >
                    {showUpdateBanner && <UpdateBanner />}
                    <AlertBanner />
                    <Grid item id="mainContainer">
                        {children}
                    </Grid>
                </Grid>
            </div>
        </Grid>
    );
};

const { isSellerWfs, cookies } = Utilities;
export default Layout;
